import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1bvyefi-0"
})(["border-radius:", ";box-shadow:", " 0 0 0 2px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiM;
});
export var AskBlock = styled.div.withConfig({
  displayName: "partials__AskBlock",
  componentId: "sc-1bvyefi-1"
})(["display:flex;align-items:center;padding:16px;background-color:#f0f6ff;font-size:13px;line-height:20px;a{flex-grow:0;flex-shrink:0;font-size:11px;line-height:18px;}", ";"], maxMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    a {\n      margin-left: auto;\n    }\n  "]))));